import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/cn';

/** Sub-navigation shared by the OnPass create + dashboard pages. */
export function OnPassTabs() {
  const tab = (to: string, label: string, end?: boolean) => (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          'rounded px-3 py-1.5 text-sm font-medium transition-colors',
          isActive ? 'bg-navy text-white' : 'text-darkGrey hover:bg-bg',
        )
      }
    >
      {label}
    </NavLink>
  );

  return (
    <nav className="mb-5 flex gap-2 border-b border-border pb-3">
      {tab('/onpass', 'Share a secret', true)}
      {tab('/onpass/active', 'My secrets')}
    </nav>
  );
}
